import React from 'react';

const Logo = () => {
  return <span className="h1 text-uppercase">banditto</span>;
};

export default Logo;
